import { ChangeEvent, SyntheticEvent, useContext, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import commonStyles from "../common.module.css";
import { AuthVerifyEmailPayload } from "../../api/types/auth";
import { FormErrors } from "../../api/types/base";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { appToastContext } from "../../context/toast";
import { useVerifyEmail } from "../../api/queries/auth/useVerifyEmail";

export default function AuthVerifyEmail() {
  const navigate = useNavigate();
  const verifyEmail = useVerifyEmail();
  const { ref: appToastRef } = useContext(appToastContext);

  const [email, setEmail] = useState<string>("");
  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) =>
    setEmail(event.target.value);

  const [errors, setErrors] = useState<FormErrors<AuthVerifyEmailPayload>>();
  const validate = (): boolean => {
    let newErrors: FormErrors<AuthVerifyEmailPayload> = {};

    if (!email) {
      newErrors.email = "";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();

    if (!validate()) {
      return;
    }

    await verifyEmail.mutateAsync({
      email,
    });

    appToastRef?.current?.show({
      severity: "info",
      summary: "The verification e-mail was successfully send.",
    });

    navigate("/login");
  };

  return (
    <form className={"col-12 p-fluid"} onSubmit={handleSubmit}>
      <Card
        title={"Resend verification e-mail"}
        className={"col-12 md:col-4 md:col-offset-4"}
      >
        <div className={"field"}>
          <label className={commonStyles.labelRequired}>E-mail:</label>
          <InputText
            value={email}
            onChange={onEmailChange}
            className={classNames({
              "p-invalid": errors?.hasOwnProperty("email"),
            })}
          />
        </div>

        <Button label={"Resend"} />
      </Card>
    </form>
  );
}
